export default function EditorialMarquee({ items }) {
    const row = [...items, ...items, ...items, ...items];
    return (
        <div className="relative border-y border-white/10 bg-[#0B1320] py-5 overflow-hidden" data-testid="editorial-marquee">
            <div className="flex whitespace-nowrap animate-marquee w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-serif text-2xl sm:text-3xl font-semibold tracking-tight text-slate-200 px-6">
                                    {item}
                                </span>
                                <span className="text-teal text-lg">✦</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
